import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./ui/slice";
import authReducer from "./auth/slice";
import userReducer from "./user/slice";
import tradesReducer from "./trades/slice";
import analyticsReducer from "./analytics/slice";
import socialReducer from "./social/slice";
import journalReducer from "./journal/slice";
import aiReducer from "./ai/slice";
import paymentsReducer from "./payments/slice";
import feedbackReducer from "./feedback/slice";
import studyReducer from "./study/slice";
import tradeReducer from "./trade";

const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    user: userReducer,
    trades: tradesReducer,
    analytics: analyticsReducer,
    social: socialReducer,
    journal: journalReducer,
    ai: aiReducer,
    payments: paymentsReducer,
    feedback: feedbackReducer,
    study: studyReducer,
    trade: tradeReducer,
  },
});

// Dev-only: expose store for browser-driven test automation (Playwright/CDP MCPs).
// Lets external tooling read state and subscribe to dispatched actions without
// the Redux DevTools extension. Stripped at production build time by CRA.
if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
  window.__store = store;
}

export default store;
